export default __webpack_public_path__ + "static/media/gs-2.db1f7a24.png";